// export const SERVER_URL = "http://68.183.31.224:5000/";

export const SERVER_URL = "https://barbearians.quest/";
export const SOCKET_ENDPOINT = "https://barbearians.quest:8151/";
export const ALLOWLIST_ENDPOINT =
  "https://barbearians.quest/api/Allowlist/checkUser";
export const REACT_APP_BASEURL = "https://barbearians.quest/";
export const REACT_APP_SOCKET_ENDPOINT = "https://barbearians.quest:8151/";
